export default 'https://data.prime-inks.com/api'